import { Component } from 'react'

export default class Carrier extends Component {
	render() {
		return <div className="page-content">Carrier</div>
	}
}
